export const DEFAULT_TIMER_SECONDS = 60;
export const CONFIRMATION_STATUS_CODES = {
  SUCCESS: 200,
  CREATED: 201,
  TOO_MANY_REQUESTS: 429,
  ERROR: 500,
  NOT_FOUND_ERROR: 404,
  PAYLOAD_ERROR: 400,
  SEND_DOUBLE_SMS: 409,
} as const;
